import { render, staticRenderFns } from "./BasicAbilityScores.vue?vue&type=template&id=ba893b7a&scoped=true&"
import script from "./BasicAbilityScores.vue?vue&type=script&lang=js&"
export * from "./BasicAbilityScores.vue?vue&type=script&lang=js&"
import style0 from "./BasicAbilityScores.vue?vue&type=style&index=0&id=ba893b7a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba893b7a",
  null
  
)

export default component.exports